module.exports = __webpack_public_path__ + "static/media/a.e9da1ca5.png";